"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.UnfilteredApptPurposes = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
var _PurposeOptions = require("../PurposeOptions");
var _styles = require("../styles");
const UnfilteredApptPurposes = _ref => {
  let {
    animKey,
    purposes,
    selectedPurpose,
    onSelect,
    virtualVisitConfig,
    ariaDescribedBy,
    legend,
    ...restProps
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_styles.ApptPurposeContainer, (0, _extends2.default)({}, restProps, {
    key: animKey
  }), purposes.length > 0 && /*#__PURE__*/_react.default.createElement(_PurposeOptions.PurposeOptions, {
    selectedPurpose: selectedPurpose,
    purposes: purposes,
    onSelect: onSelect,
    virtualVisitConfig: virtualVisitConfig,
    ariaDescribedBy: ariaDescribedBy,
    legend: legend
  }));
};
exports.UnfilteredApptPurposes = UnfilteredApptPurposes;
UnfilteredApptPurposes.propTypes = {
  purposes: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    name: _propTypes.string,
    visit_method: _propTypes.string,
    highlightedName: _propTypes.string
  })).isRequired,
  /* Internal key used for animation */
  animKey: _propTypes.string.isRequired,
  /**
   * Set appointment purpose once fired 'onSelectPurpose' callback function
   */
  selectedPurpose: (0, _propTypes.shape)({
    name: _propTypes.string.isRequired
  }),
  /**
   * callback function to select appointment purpose
   */
  onSelect: _propTypes.func.isRequired,
  /**
   * Label text to be display when virtual visit exists
   */
  virtualVisitConfig: (0, _propTypes.shape)({
    phone: _propTypes.string,
    video: _propTypes.string,
    in_person: _propTypes.string
  }).isRequired,
  ariaDescribedBy: _propTypes.string.isRequired,
  legend: _propTypes.string.isRequired
};
UnfilteredApptPurposes.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "UnfilteredApptPurposes",
  "props": {
    "purposes": {
      "description": "",
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "shape",
          "value": {
            "name": {
              "name": "string",
              "required": false
            },
            "visit_method": {
              "name": "string",
              "required": false
            },
            "highlightedName": {
              "name": "string",
              "required": false
            }
          }
        }
      },
      "required": true
    },
    "animKey": {
      "description": "",
      "type": {
        "name": "string"
      },
      "required": true
    },
    "selectedPurpose": {
      "description": "Set appointment purpose once fired 'onSelectPurpose' callback function",
      "type": {
        "name": "shape",
        "value": {
          "name": {
            "name": "string",
            "required": true
          }
        }
      },
      "required": false
    },
    "onSelect": {
      "description": "callback function to select appointment purpose",
      "type": {
        "name": "func"
      },
      "required": true
    },
    "virtualVisitConfig": {
      "description": "Label text to be display when virtual visit exists",
      "type": {
        "name": "shape",
        "value": {
          "phone": {
            "name": "string",
            "required": false
          },
          "video": {
            "name": "string",
            "required": false
          },
          "in_person": {
            "name": "string",
            "required": false
          }
        }
      },
      "required": true
    },
    "ariaDescribedBy": {
      "description": "",
      "type": {
        "name": "string"
      },
      "required": true
    },
    "legend": {
      "description": "",
      "type": {
        "name": "string"
      },
      "required": true
    }
  }
};